import { defineComponent as _defineComponent } from 'vue'
import { computed, provide, ref, onBeforeMount } from 'vue';
import { useRouter } from 'vue-router/composables';
import { notify } from '@/modules/common/helpers/notification';
import { NotificationTypes } from '@/modules/common/services/http/notification';

import { NavBar, ProgressBar } from '@warrenbrasil/nebraska-web';
import { FadeTransition } from '@/modules/common/components/FadeTransition';
import { BackButton } from '@/modules/common/components/buttons';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';

import { EFundsSteps, FundsBuilderComponents, IFundsData } from './helpers';

import {
  getPortfolioSheet,
  createPortfolio,
  IPortfolioSheet,
  ICreatePortfolio
} from '@/modules/catalog/services/funds';

interface Props {
  askForInvestorType?: boolean;
  type: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FundsBuilder',
  props: {
    askForInvestorType: { type: Boolean },
    type: null
  },
  setup(__props: any) {

const props = __props as {
  askForInvestorType?: boolean;
  type: string;
}

const router = useRouter();



const isLoading = ref(false);
const portfolioSheet = ref<IPortfolioSheet | null>(null);
const conclusionDetails = ref<ICreatePortfolio | null>(null);
const currentStep = ref(EFundsSteps.PROFILE);
const data = ref<IFundsData>({
  risk: { id: '', formatted: '', value: 0 },
  type: props.type
});

const showNavbar = computed(() => {
  return (
    currentStep.value !== EFundsSteps.TEMPLATE &&
    currentStep.value !== EFundsSteps.CONCLUSION
  );
});

const progress = computed(() => {
  return (currentStep.value + 1) * 0.5;
});

const step = computed(() => {
  return {
    component: FundsBuilderComponents[currentStep.value]
  };
});

function onBack() {
  if (currentStep.value === EFundsSteps.PROFILE) {
    router.push({ name: 'catalog' });

    return;
  }

  if (
    currentStep.value - 1 === EFundsSteps.PROFILE &&
    !props.askForInvestorType
  ) {
    router.push({ name: 'catalog' });

    return;
  }

  currentStep.value = currentStep.value - 1;
}

async function updateData(key: string, value: string | number | object) {
  data.value = {
    ...data.value,
    [key]: value
  };

  if (key === 'risk') {
    await fetchPortfolioSheet();

    return;
  }

  currentStep.value = currentStep.value + 1;
}

async function fetchPortfolioSheet() {
  try {
    isLoading.value = true;

    portfolioSheet.value = await getPortfolioSheet(
      data.value.risk.id,
      props.type,
      data.value.profile?.value
    );

    currentStep.value = EFundsSteps.TEMPLATE;
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível carregar as informações desta carteira. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

async function fetchCreatePortfolio() {
  try {
    isLoading.value = true;

    const params = {
      managedPortfolioId: data.value.risk.id,
      type: props.type,
      name: portfolioSheet.value!.header.title,
      investorType: data.value.profile?.value || 'Common'
    };

    conclusionDetails.value = await createPortfolio(params);

    currentStep.value = EFundsSteps.CONCLUSION;
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Não foi possível criar a carteira. Aguarde alguns instantes e tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

onBeforeMount(async () => {
  currentStep.value = props.askForInvestorType
    ? EFundsSteps.PROFILE
    : EFundsSteps.RISK;
});

provide('data', data);
provide('portfolioSheet', portfolioSheet);
provide('isLoading', isLoading);
provide('conclusionDetails', conclusionDetails);

provide('createPortfolio', fetchCreatePortfolio);
provide('updateData', updateData);
provide('onBack', onBack);

return { __sfc: true,router, props, isLoading, portfolioSheet, conclusionDetails, currentStep, data, showNavbar, progress, step, onBack, updateData, fetchPortfolioSheet, fetchCreatePortfolio, NavBar, ProgressBar, FadeTransition, BackButton, NebraskaColors }
}

})